<template>
  <div class="meeting-login">
    <div class="logo">
      <div class="logobottom">
        <p class="logobottom1">
          <img src="../assets/images/top.png" alt /> 欢迎使用
        </p>
        <p class="logobottom2">西北政法可视化管理中心</p>
      </div>
    </div>
    <div class="login-box">
      <div class="logintext">登录</div>
      <el-form label-width="80px" label-position="left" :model="formData" ref="form" :rules="rules" size="small">
        <p>账户</p>
        <el-form-item style="position:relative" label="用户名" prop="username">
          <el-input v-model="formData.username" @keyup.enter.native="clickLogin" placeholder="请输入用户名">
            <i slot="suffix" class="iconfont iconicon-test120"></i>
          </el-input>
        </el-form-item>
        <p>密码</p>
        <el-form-item style="position:relative" label="输入密码" prop="password">
          <el-input type="password" v-model="formData.password" @keyup.enter.native="clickLogin" placeholder="请输入密码">
            <i slot="suffix" class="iconfont iconicon-test54"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="loginBtn" @click.stop="clickLogin">登 录</el-button>
        <div class="btn-box-shadow"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { setToken, getToken, setOnlineKey, getOnlineKey, getBrowser, removeToken, removeOnlineKey } from '@/assets/js/http.js'
export default {
  data () {
    return {
      formData: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      },
      redirect: undefined,
    }
  },
  created () {
    // this.getUserInfo()
  },
  methods: {
    // getTokenKey (code, username) {
    //   this.removeCookies()
    //   let data = {
    //     code: code,
    //     username: username,
    //   }
    //   this.$post('/ioc-prod-api/login', data).then(res => {
    //     if (res.code === 200) {
    //       setToken(res.token)
    //       setOnlineKey(res.onlineKey)
    //       // this.getUserInfo()
    //     }
    //   })
    // },
    getUserInfo () {
      this.$http('/odpsmanage/getact.osp', {
        method: 'get',
        params: {}
      }).then(res => {
        // this.$store.commit('set_user', res.user)
        localStorage.setItem("user", JSON.stringify(res.data))
        // this.$router.push('/layout/home')
      })
    },
    removeCookies () {
      removeToken()
      removeOnlineKey()
    },
    casLogin () { // cas认证
      this.removeCookies()
      let url = window.location.href
      this.$http('/prod-api/casLogin', { method: 'get', params: { state: url } }).then(res => {
        if (res.code != 200) {
          return;
        }
        if (res.msg === 'cas_login_url') {
          window.location.href = res.data;
          return;
        } else if (res.msg === 'cas_validate_url') {
          window.location.href = res.data;
          return;
        }
      }).catch(e => {
        // window.location.reload()
      })
    },
    wxLogin () { // 微信认证
      this.removeCookies()
      let url = window.location.href
      this.$http('/prod-api/wxLogin', { method: 'get', params: { state: url } }).then(res => {
        if (res.msg === 'get_code_url_full') {
          window.location.href = res.data;
          return;
        } else {
        }
      }).catch(e => {
        // window.location.reload();
      })
    },
    isStringEmpty (obj) {
      if (obj === "undefined" || obj == null || obj === "") {
        return true;
      } else {
        return false;
      }
    },
    isWxBrowser () {
      return getBrowser() === 'wechat';
      return navigator.userAgent.toLowerCase().indexOf("wechat") > -1
    },
    clickLogin () {
      this.removeCookies()
      let data = {
        // L: this.formData.username,
        // P: this.formData.password,
        // code: '',
        // uuid: '',
      }
      this.$post('/odpsmanage/login.osp?L=' + this.formData.username + '&P=' + this.formData.password).then(res => {
        if (res.code === "000000") {
          setToken(res.data.token)
          // setOnlineKey(res.onlineKey)
          this.getUserInfo()
          this.$router.push('/home')
        } else {
          this.$message.error('账号或密码错误');
        }
      })
      // this.$post('/ioc-prod-api/login', data).then(res => {
      //   if (res.code === 200) {
      //     setToken(res.token)
      //     setOnlineKey(res.onlineKey)
      //     this.getUserInfo()
      //     this.$router.push('/layout/home')
      //   } else if (res.code === 10) {
      //     let aginData = { loginType: 'loginAgin', username: this.formData.username, password: this.formData.password }
      //     this.$post(`/ioc-prod-api/login`, aginData).then(res1 => {
      //       if (res1.code === 200) {
      //         setToken(res1.token)
      //         setOnlineKey(res1.onlineKey)
      //         this.getUserInfo()
      //         this.$router.push('/layout/home')
      //       }
      //     })
      //   }
      // })
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
}
</script>
<style scoped lang='stylus'>
.meeting-login
  position fixed
  width 100%
  height 100%
  min-width 1440px
  // height 100vh
  background-color transparent !important
  box-shadow none !important
  background-image url('~@assets/images/login.png')
  background-repeat no-repeat
  background-size 65% 100%
  min-height 768px
  .logo
    // height 100vh
    // background-image url('~@assets/images/top.png')
    // background-repeat: no-repeat
    // background-position:left 56px bottom 119px
    .logotop
      height 55px
      line-height 55px
      border-bottom 1px solid $c7
      color $c7
      font-size 16px
      padding-left 35px
    .logobottom
      position absolute
      left 65px
      bottom 61px
      color $c7
      .logobottom1
        font-size 48px
        margin-bottom 20px
      .logobottom2
        font-size 36px
        margin-left 60px
  .login-box
    position absolute
    top 286px
    bottom 0
    left 60%
    margin auto
    z-index 10
    >>>.el-form-item__label
      color #FFFFFF
    >>>.el-input__inner
      background #F9F9FA
      width 500px
      height 48px
      line-height 48px
      font-size 14px
    .logintext
      margin-bottom 30px
      font-size 24px
      font-family Microsoft YaHei UI
      font-weight bold
      color #1D1F29
    p
      color #1D1F29
      height 21px
      font-size 16px
      margin-top 36px
    .form-box
      height 100%
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      margin auto
      marign-top 50px
      text-align center
      .activate-text
        font-size 13px
        position relative
        background #fff
        text-align center
        width 80%
        height 60px
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        .text
          color $c5
          font-weight bold
        .text:before
          content ''
          display inline-block
          width 30%
          height 1px
          background $c5
          vertical-align middle
        .text:after
          content ''
          display inline-block
          width 30%
          height 1px
          background $c5
          vertical-align middle
    .btn-box
      // position relative
      // margin-top 20px
      // display flex
      // width 500px
      // margin auto
      .loginBtn
        flex 1
        height 48px
        width 500px
        z-index 3
        position relative
        border-radius 0
        border none
        margin-top 70px
        background #097AEE !important
        color $c7
        >>> .el-icon-loading
          color #fff
    >>>.el-form-item__label
      display none
    >>>.el-form-item__content
      margin-left 0px !important
</style>